import Layout from '@/layout'

const articleManager = {
  path: '/knowledge',
  component: Layout,
  redirect: '/article-manager/article',
  name: 'knowledge',
  meta: {
    title: '知识库管理',
    icon: 'el-icon-s-management',
    roles: ['sls_knowledge']
  },
  children: [
    {
      path: 'article',
      component: () => import('@/views/article-manager/article'),
      name: 'article',
      meta: { title: '文章列表', roles: ['sls_knowledge_list'] }
    },
    {
      path: 'article_create',
      component: () => import('@/views/article-manager/create'),
      name: 'articleCreate',
      meta: { title: '创建文章', roles: ['sls_knowledge_create'] }
    },
    {
      path: 'edit/:id(\\d+)',
      component: () => import('@/views/article-manager/edit'),
      name: 'articleEdit',
      meta: { title: '修改文章', noCache: true, roles: ['sls_knowledge_list'] },
      hidden: true
    },
    {
      path: 'check/:id(\\d+)',
      component: () => import('@/views/article-manager/check'),
      name: 'articleCheck',
      meta: { title: '查看文章', noCache: true, roles: ['sls_knowledge_check'] },
      hidden: true
    },
    {
      path: 'articleReview',
      component: () => import('@/views/article-manager/articleReview'),
      name: 'articleReview',
      meta: { title: '文章审核', roles: ['sls_knowledge_approval'] },
      hidden: true
    },
    {
      path: 'article_type',
      component: () => import('@/views/article-manager/articleType'),
      name: 'articleType',
      meta: { title: '文章类型', roles: ['sls_knowledge_type'] }
    }
  ]
}
export default articleManager
